define('shared/util/ValidationBinder',['shared/lib/RSVP', 'shared/lib/Emitter'], function(RSVP, Emitter){
    'use strict';
    
    var abort = {};

    /* Constructor */
    function Ctor(){
        var me = this;
        me.detail = null;
        me.options = null;

        me._subValidateWrapper = function(){
            var item = this;
            var combinedItem = item.combinedField && item.combinedField !== ''?me.detail[item.combinedField.toLowerCase()]:null;
            var prm;

            if (combinedItem && typeof combinedItem._validate === 'function') {
                prm = combinedItem._validate()
                    .then(null, function(){
                        return item._validate();
                    });
            }
            else {
                prm = item._validate();
            }

            function onSuccess(){
                if (typeof item.onsuccess === 'function'){
                     item.onsuccess();
                }

                if ( me.options && me.options.onsuccess ) {
                    me.options.onsuccess(item);
                }
            }

            item.promise = prm
                .then(onSuccess, function( reason ){
                    var args = Array.prototype.slice.call(arguments);
                        args.unshift(item);
                        
                    return new RSVP.Promise(function( resolve, reject ){

                        if (typeof item.onerror === 'function') {
                            item.onerror();
                        }

                        if ( me.options && me.options.onerror ) {
                            me.options.onerror.apply(me.options, args);
                        }

                        reject( reason );
                    });
                });

            return item.promise;
        };

        Emitter(this);
    }

    Ctor.prototype = {
        constructor: Ctor,

        /**
         * Setup the validation
         */
        setup: function( config ){
            var me = this;
            var item;

            if ( config == null || 
                config.detail == null || 
                config.$form == null || 
                config.$form.length <= 0) {
                throw new Error('Please specify validation configuration and details');
            }

            var $form = me.$el = config.$form;
            var detail = me.detail = config.detail;
            me.options = config.options;

            if (me.required()) {
                for( var key in detail ) {
                    if ( !detail.hasOwnProperty(key) ) {
                        continue;
                    }

                    item = detail[ key ];

                    if ( item.$el && item.$el.length > 0 ) {
                        item.$el.on('focus', function(item){
                            return function(){
                                if (item && typeof item.reset === 'function') {
                                    item.reset();
                                }
                            };
                        }(item));
                        item.$el.on('blur', function(item){
                            return function(){
                                item.validate();
                            };
                        }(item));
                        item._validate = item.validate;
                        item.validate = me._subValidateWrapper;
                        if (typeof item.setup === 'function') {
                            item.setup();
                        }
                    }
                }
            }

            $form
                .on('submit', function(evt){
                    evt.preventDefault();

                    function handleSubmitFail( reason ) {
                        if ( reason == abort ) {
                            return;
                        }

                        return new RSVP.Promise(function(resolve, reject){
                            me.emit.call(me, 'submitfail', reason);

                            reject( abort );
                        });
                    }

                    

                    RSVP.resolve()
                        .then(function(){
                            var dfd = RSVP.defer();

                            if ( me.hasListeners('beforevalidate') ) {
                                me.emit('beforevalidate', dfd);
                            }
                            else {
                                dfd.resolve();     
                            }

                            return dfd.promise;
                        })
                        .then(function(){
                            return me.validate();
                        })
                        .then(function(){
                            return RSVP.resolve()
                                .then(function(){
                                    var dfd = RSVP.defer();
                                    
                                    if ( me.hasListeners('beforesubmit') ) {
                                        me.emit( 'beforesubmit', dfd, evt );
                                    }
                                    else {
                                        dfd.resolve();     
                                    }

                                    return dfd.promise;
                                })
                                .then(function(){
                                    var dfd = RSVP.defer();

                                    if ( me.hasListeners('submit') ) {
                                        me.emit( 'submit', dfd, evt );
                                    }
                                    else {
                                        $form[0].submit();
                                        dfd.resolve();
                                    }
                                    
                                    return dfd.promise;
                                }, handleSubmitFail)
                                .then(function( data ){
                                    var dfd = RSVP.defer();

                                    if ( me.hasListeners('aftersubmit') ) {
                                        me.emit( 'aftersubmit', dfd, evt, data );
                                    }
                                    else {
                                        dfd.resolve();
                                    }

                                    return dfd.promise;
                                }, handleSubmitFail)
                                .then(function(){
                                    var dfd = RSVP.defer();

                                    if ( me.hasListeners('submitsuccess') ) {
                                        me.emit( 'submitsuccess', dfd );
                                    }
                                    else {
                                        dfd.resolve();
                                    }

                                    return dfd.promise;
                                }, handleSubmitFail);
                        }, function(){
                            var dfd = RSVP.defer();

                            if ( me.hasListeners('validationfail') ) {
                                me.emit( 'validationfail', dfd);
                            }
                            else {
                                dfd.resolve();     
                            }

                            return dfd.promise;
                        });
                })
                .attr('novalidate', 'novalidate');
        },
        /**
         * Resolve true if all sub items are validated
         */
        validate: function(){
            var detail = this.detail;
            var item;
            var dfds = [];

            for(var key in detail ) {
                if ( !detail.hasOwnProperty(key) ) {
                    continue;
                }

                item = detail[ key ];

                if (
                    item.$el &&
                    item.$el.length > 0 &&
                    item.$el.is('[disabled]') == false
                ) {
                    dfds.push( item.validate() );
                }
            }

            return RSVP.all(dfds);
        },
        /**
         * Return true if any of sub item is required to be validated 
         */
        required: function(){
            var detail = this.detail;
            var item;
            var ret = false;

            for(var key in detail ) {
                if ( !detail.hasOwnProperty(key) ) {
                    continue;
                }

                item = detail[ key ];

                if ( item.$el != null && item.$el.length > 0 ) {
                    ret = true;
                    break;
                }
            }

            return ret;
        }
    };

    return Ctor;
});
